import Image from 'next/image';
import houseSrc from 'public/assets/icons/house.png';
import Link from 'next/link';
import map from 'lodash/map';
import { Fragment } from 'react';
import MicroData, { MICRODATA_BREADCRUMBS } from '@/grandus-lib/components-atomic/MicroData';

const Breadcrumbs = ({ data = [], current = '', invert = false }) => {
  return (
    <>
      <MicroData
        data={{ ...data, ...{ current: current } }}
        type={MICRODATA_BREADCRUMBS}
      />
      <div className={'py-6'}>
        <div
          className={
            'py-2 flex flex-nowrap items-center text-sm justify-start overflow-x-auto'
          }
        >
          <div className={'mr-2 mb:mr-4 shrink-0'}>
            <Link href={'/'} className={'top-[0px] relative bottom-[3px]'}>
              <Image
                src={houseSrc}
                alt={''}
                width={15}
                height={15}
                className={`block w-[15px] h-[15px] ${invert ? "invert" : ""}`}
              />
            </Link>
          </div>

          {map(data, (item, i) => {
            return (
              <Fragment key={`breadcrumb-item-${i}`}>
                <div className={'px-2'}>/</div>
                <Link
                  href={item.href ?? '#'}
                  className={'underline hover:no-underline text-nowrap'}
                >
                  {item.name}
                </Link>
              </Fragment>
            );
          })}

          {current ? (
            <>
              <div className={'px-2'}>/</div>
              <div className={'text-nowrap'}>{current}</div>
            </>
          ) : (
            ''
          )}
        </div>
      </div>
    </>
  );
};

export default Breadcrumbs;
